client let stars: undefined | number;
client let downloads: undefined | number;

script --
  getStars().then((stars) =>
    document.documentElement.style.setProperty("--stars", stars.toString()),
  );
  getDownloads().then((downloads) => {
    document.documentElement.style.setProperty(
      "--downloads",
      downloads.toString(),
    );
  });
client async function getStars() {
  return (stars ??= (
    await (await fetch("https://api.github.com/repos/marko-js/marko")).json()
  ).stargazers_count as number);
}
client async function getDownloads() {
  return (downloads ??= (
    await (
      await fetch("https://api.npmjs.org/downloads/point/last-month/marko")
    ).json()
  ).downloads as number);
}
